<form *ngIf="form"
      [formGroup]="form">
  <app-input [label]="'common_answer' | translate"
             [placeholder]="'common_put_your_answer' | translate"
             formControlName="answer"
  ></app-input>
</form>
